import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import type { Breadcrumb } from '@/types/shared'
import { Form } from './components/Form'

type PrefectureOption = {
  code: number
  name: string
}

type AdminSchoolNewProps = {
  school: {
    id?: string
    name: string | null
    prefectureId: number | null
    league: string | null
  }
  options: {
    prefectures: PrefectureOption[]
  }
  breadcrumbs: Breadcrumb[]
}

export default function New({ school, options, breadcrumbs }: AdminSchoolNewProps) {
  return (
    <AppShell>
      <Head title="新規高校登録" />
      <PageHeader
        title="新規高校登録"
        description="高校マスターを新しく登録します。"
        breadcrumbs={breadcrumbs}
      />
      <Form
        values={school}
        prefectures={options.prefectures}
        mode="create"
      />
    </AppShell>
  )
}
